import styled, { css } from 'styled-components';
import { FontAddiFamilyPrimaryName, FontAddiFamilySecondaryName, FontAddiWeightExtraBold, FontAddiWeightRegular, FontAddiWeightMedium, FontAddiWeightBold, } from '@addi/foundation/dist/web/fonts';
import { ColorAddiFontPrimary, ColorAddiFontAction, ColorAddiFontError, ColorAddiFontHint, ColorAddiFontSecondary, ColorAddiFontSuccess, ColorAddiFontOverDark, } from '@addi/foundation/dist/web/colors';
import { SizeAddiFontXxxLarge, SizeAddiFontXxLarge, SizeAddiFontXLarge, SizeAddiFontLarge, SizeAddiFontBase, SizeAddiFontSmall, SizeAddiFontXSmall, SizeAddiFontXxSmall, SizeAddiFontXxxSmall, } from '@addi/foundation/dist/web/sizes';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
const ParagraphColors = {
    primary: ColorAddiFontPrimary,
    secondary: ColorAddiFontSecondary,
    hint: ColorAddiFontHint,
    error: ColorAddiFontError,
    success: ColorAddiFontSuccess,
    action: ColorAddiFontAction,
    overDark: ColorAddiFontOverDark,
};
const FontStyle = css `
  font-style: ${({ fontStyle }) => (fontStyle ? fontStyle : 'normal')};
`;
export const PrimaryFont = css `
  font-family: ${FontAddiFamilyPrimaryName};
  ${FontStyle}
`;
export const SecondaryFont = css `
  font-family: ${FontAddiFamilySecondaryName};
  ${FontStyle}
`;
export const Header1 = styled.h1 `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontXxxLarge};
    color: ${ColorAddiFontPrimary};
`;
export const Header2 = styled.h2 `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontXxLarge};
    color: ${ColorAddiFontPrimary};
`;
export const Header3 = styled.h3 `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontXLarge};
    color: ${ColorAddiFontPrimary};
`;
export const Title = styled.h4 `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontLarge};
    color: ${ColorAddiFontPrimary};
`;
export const Subtitle = styled.h5 `
    ${PrimaryFont}
    font-weight: ${({ strong }) => (strong ? FontAddiWeightExtraBold : FontAddiWeightRegular)};
    font-size: ${SizeAddiFontBase};
    color: ${ColorAddiFontPrimary};
`;
export const Paragraph = styled.p `
    ${SecondaryFont}
    font-weight: ${({ strong }) => (strong ? FontAddiWeightBold : FontAddiWeightMedium)};
    font-size: ${({ small }) => (small ? SizeAddiFontXSmall : SizeAddiFontSmall)};
    color: ${({ fontColor }) => (fontColor ? ParagraphColors[fontColor] : ColorAddiFontPrimary)};
`;
export const Caption = styled.span `
    ${SecondaryFont}
    font-weight: ${({ strong }) => (strong ? FontAddiWeightExtraBold : FontAddiWeightMedium)};
    font-size: ${SizeAddiFontXxSmall};
    color: ${ColorAddiFontPrimary};
`;
export const Pretitle = styled.span `
    ${SecondaryFont}
    font-weight: ${FontAddiWeightExtraBold};
    font-size: ${SizeAddiFontXxxSmall};
    color: ${ColorAddiFontPrimary};
`;
export const Label = styled.label `
    ${SecondaryFont}
    font-weight: ${({ strong }) => (strong ? FontAddiWeightExtraBold : FontAddiWeightMedium)};
    font-size: ${SizeAddiFontXxSmall};
    color: ${ColorAddiFontPrimary};
`;
export const ButtonTextLarge = css `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightBold};
    font-size: ${SizeAddiFontBase};
`;
export const ButtonTextMedium = css `
    ${SecondaryFont}
    font-weight: ${FontAddiWeightBold};
    font-size: ${SizeAddiFontSmall};
`;
export const ButtonTextSmall = css `
    ${PrimaryFont}
    font-weight: ${FontAddiWeightBold};
    font-size: ${SizeAddiFontXSmall};
`;
export const Link = styled.a `
    ${SecondaryFont}
    font-weight: ${FontAddiWeightMedium};
    font-size: ${SizeAddiFontXxSmall};
    color: ${ColorAddiFontAction};
    cursor: pointer;
    text-decoration: none;
`;
export const MainTitlePage = styled(Header2) `
  margin: 8px 0 4px 0;
  line-height: 24.8px;
  &&& {
    font-size: ${SizeAddiFontBase};
  }

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    line-height: 48.4px;
    &&& {
      font-size: ${SizeAddiFontXLarge};
    }
  }
`;
export const FullWidthSpaceBetweenContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
//# sourceMappingURL=Typpographies.styled.js.map